
import Nav from "@/components/Landing/Nav/Nav.vue";

export default {
  name: "NotFound",
  props: ["auth", "authenticated"],
  components: {
    Nav
  },
  data() {
    return {
      authFlag: this.$props.authenticated,
    }
  }
};
